<template>
  <!-- 商户信息管理，用于通联支付对接 -->
  <div class="">
    <list-page>
      <search-condition @search="resetSearch" :show-search="true">
        <template #default>
          <el-input v-model="searchInfo.searchKey" placeholder="请输入查询关键字" @keydown.enter="resetSearch">
            <template #prefix>关键字</template>
          </el-input>
        </template>
        <template #option>
          <page-button type="read" el-type="primary" @click="resetSearch">查询</page-button>
          <page-button type="write" el-type="success" @click="toEdit({})">新建</page-button>
        </template>
      </search-condition>
      <list-table>
        <yq-table :data="dataList" height="100%" stripe border >
          <yq-table-column  label="关键字" prop="keyName" min-width="180rem"/>
          <yq-table-column label="创建时间" prop="createdTime" width="180rem"/>
          <yq-table-column  label="操作" prop="options" :align="'center'" fixed="right" width="120rem" :show-overflow-tooltip="false">
            <template v-slot="{row}">
              <table-button-group label="更多操作">
                <table-button @click="toEdit(row)">编辑</table-button>
                <table-button  el-type="danger" message="是否确认删除数据" @click="toDelete(row)">删除</table-button>
              </table-button-group>
            </template>
          </yq-table-column>
        </yq-table>
      </list-table>
      <form-page v-model:page-number="searchInfo.pageNumber" v-model:page-size="searchInfo.pageSize" :total-count="searchInfo.totalCount" @onLoad="queryList"/>
    </list-page>
    <el-dialog v-model="showDetail" title="管理关键字" dialog-width="1">
      <form-items :data="currentData" ref="KeyWordEdit" label-width="2.4rem" :columns="1">
        <form-item label="关键字" :required="true" name="keyName" error-message="请输入关键字">
          <el-input v-model="currentData.keyName" placeholder="请输入关键字" />
        </form-item>
      </form-items>
      <template #footer>
        <el-button @click="showDetail = false">取消</el-button>
        <el-button type="primary" @click="toSave">确认</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>

import SearchCondition from "@/components/h5/layout/SearchCondition.vue";
import FormPage from "@/components/h5/layout/FormPage.vue";
import ListTable from "@/components/h5/layout/ListTable.vue";
import ListPage from "@/components/h5/layout/ListPage.vue";
import TableButton from "@/components/h5/button/TableButton.vue";
import TableButtonGroup from "@/components/h5/button/TableButtonGroup.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
import Util from "@/util/util";
import {useRoute, useRouter} from "vue-router";
import qywxQuotationKeyWordApi from "@/api/dz-ai/qywxQuotationKeyWordApi";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
export default {
  setup() {
    return {
      router: useRouter(),
      route: useRoute(),
    }
  },
  name: "KeyWords",
  components: {
    YqTableColumn, TableButtonGroup, TableButton, SearchCondition, FormPage, ListTable, ListPage, FormItems, FormItem
  },
  data() {
    return {
      searchInfo: {},
      dataList: [],
      currentData: {
        keyName: ""
      },
      showDetail:  false,
    };
  },
  beforeRouteLeave(to, from, next) {
    // 将当前页面数据进行缓存
    Util.cachePageData(this, to, from);
    next();
  },
  created() {
    if (!Util.loadPageData(this)) { // 加载缓存数据失败，初始化页面
      this.resetSearch();
    }
  },
  methods: {
    queryList() {
      qywxQuotationKeyWordApi.queryGroupKeyWordList(this.searchInfo).then(res => {
        this.dataList = res.records;
        this.searchInfo.totalCount = res.totalCount;
      })
    },
    resetSearch() {
      this.searchInfo.pageNumber = 1;
      this.queryList();
    },
    toEdit(row) {
      this.currentData = {...row};
      this.showDetail = true;
    },
    toDelete(row) {
      qywxQuotationKeyWordApi.deleteKeyWord(row.id).then(() => {
        this.queryList();
      })
    },
    toSave() {
      if (!this.$refs.KeyWordEdit.validCheck()) {
        return;
      }
      qywxQuotationKeyWordApi.saveKeyWord(this.currentData).then(() => {
        this.queryList();
        this.showDetail = false;
      })
    }
  }
};
</script>

<style lang="scss" scoped>
</style>